import { type FeatureFlag } from '@prisma/client'

export const hasFeatureFlag = (
  flag: FeatureFlag,
  availableFlags?: FeatureFlag[] | null // typing is intentionally loose
) => {
  if (!availableFlags) return false
  return availableFlags.includes(flag)
}
